<template>
    <div class="container">
        <Card class="firehydrant-card">
            <template #header> </template>
            <template #title>รายละเอียดหัวจ่ายน้ำดับเพลิง</template>
            <template #content>
                <div class="scrollable-content">
                    <ul v-if="firehydrantData" class="firehydrant-details">
                        <li><strong>รหัสหัวจ่ายน้ำดับเพลิง:</strong> {{ firehydrantData.code || '-' }}</li>
                        <li><strong>ขนาด:</strong> {{ firehydrantData.pipe_size || '-' }}</li>
                        <li><strong>ซอย/ตรอก :</strong> {{ firehydrantData.soi_name || '-' }}</li>
                        <li><strong>ถนน:</strong> {{ firehydrantData.road_name || '-' }}</li>
                        <li><strong>ชุมชน:</strong> {{ firehydrantData.community_name || '-' }}</li>
                        <li><strong>สถานะ:</strong> {{ firehydrantData.status || '-' }}</li>
                        <li><strong>สถานีดับเพลิงและกู้ภัย:</strong> {{ firehydrantData.fire_station || '-' }}</li>
                        <li><strong>ที่ตั้ง:</strong> {{ firehydrantData.location || '-' }}</li>
                        <li><strong>แขวง/ตำบล:</strong> {{ firehydrantData.fh_tambon_name || '-' }}</li>
                        <li><strong>เขต/อำเภอ:</strong> {{ firehydrantData.fh_amphur_name || '-' }}</li>
                        <li><strong>จังหวัด:</strong> {{ firehydrantData.fh_province_name || '-' }}</li>
                        <li><strong>รหัสไปรษณีย์:</strong> {{ firehydrantData.postcode || '-' }}</li>
                        <li><strong>รายละเอียดการตรวจสอบ :</strong> {{ firehydrantData.inspec_details || '-' }}</li>
                        <li><strong>ละติจูด :</strong> {{ firehydrantData.event_lat || '-' }}</li>
                        <li><strong>ลองจิจูด :</strong> {{ firehydrantData.event_lon || '-' }}</li>
                        <li><strong>วันที่สร้างข้อมูล:</strong> {{ formatThaiDate(firehydrantData.date_create_ddmmyy) || '-' }}</li>
                        <li><strong>วันที่ปรับปรุงข้อมูล:</strong> {{ formatThaiDate(firehydrantData.date_update_ddmmyy) || '-' }}</li>
                        <li><strong>หน่วยงานที่ดูแล:</strong> {{ firehydrantData.organize_name || '-' }}</li>
                    </ul>
                </div>
            </template>
        </Card>
    </div>
</template>

<script>
import axios from 'axios';
import Card from 'primevue/card';

export default {
    name: 'ExtinguisherDetails',
    components: {
        Card
    },
    mounted() {
        if (this.$route.query.firehydrantId) {
            console.log('this.$route.query.firehydrantId', this.$route.query.firehydrantId);
            this.inputCode = this.$route.query.firehydrantId;
            this.getFireHydrant_id();
            setTimeout(() => {
                this.leavePage();
            }, 60 * 1000 * 5);
        }
    },
    data() {
        return {
            inputCode: '',
            firehydrantData: null
        };
    },
    created() {
        window.onpopstate = () => {
            this.$router.push('/');
        };
    },
    methods: {
        leavePage() {
            this.$router.push('/map-disaster');
        },

        getTelDetails(jsonString) {
            if (!jsonString) return '';
            const telDetailArray = JSON.parse(jsonString);
            return telDetailArray
                .map((detail) => {
                    return Object.values(detail)
                        .filter((val) => val !== '-')
                        .join(', ');
                })
                .join(', ');
        },
        formatThaiDate(date) {
            if (!date) return null;

            // Handle different date formats
            let d;
            if (typeof date === 'string') {
                // Check if date is in DD/MM/YYYY format
                const parts = date.split('/');
                if (parts.length === 3) {
                    // Convert from DD/MM/YYYY to Date object
                    d = new Date(parts[2], parts[1] - 1, parts[0]);
                } else {
                    // Try parsing as regular date string
                    d = new Date(date);
                }
            } else {
                d = new Date(date);
            }

            // Validate date
            if (isNaN(d.getTime())) {
                return null;
            }

            const thaiMonths = [
                'มกราคม',
                'กุมภาพันธ์',
                'มีนาคม',
                'เมษายน',
                'พฤษภาคม',
                'มิถุนายน',
                'กรกฎาคม',
                'สิงหาคม',
                'กันยายน',
                'ตุลาคม',
                'พฤศจิกายน',
                'ธันวาคม'
            ];

            const day = d.getDate();
            const month = thaiMonths[d.getMonth()];
            const year = d.getFullYear() + 543; // Convert to Thai Buddhist year

            return `${day} ${month} ${year}`;
        },

        async getFireHydrant_id() {
            try {
                console.log('Fetching data for code:', this.inputCode);
                const firehydrantId = this.inputCode;

                const response = await axios.post(
                    `${this.$url_service}/read/fireHydrant/data/${firehydrantId}`,
                    {},
                    {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    }
                );

                const data = response.data;
                console.log('data:', data);
                if (data.code === 'success') {
                    this.firehydrantData = data.data[0];
                } else {
                    console.error('Error fetching data:', data.message);
                    if (data.code === 'timeout') {
                        this.$router.push('/');
                    }
                }
            } catch (error) {
                console.error('Error:', error);
                this.$router.push('/'); // Redirect on error
            }
        }
    }
};
</script>

<style scoped>
.container {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
    background-color: #f5f5f5;
    padding: 20px;
}

.firehydrant-card {
    width: 100%;
    max-width: 400px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    background-color: #fff;
    padding: 20px;
}

.firehydrant-details {
    list-style: none;
    padding: 0;
    margin: 0;
    font-size: 1rem;
    line-height: 1.5;
    color: #333;
}

.firehydrant-details li {
    padding: 0.5em 0;
    border-bottom: 1px solid #eee;
}

.scrollable-content {
    max-height: 300px;
    overflow-y: auto;
    padding-right: 1em; /* Add padding to avoid content being hidden by scrollbar */
}

/* Small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
    .firehydrant-card {
        width: 100%;
        padding: 10px;
    }
}

/* Medium devices (tablets, 600px to 768px) */
@media only screen and (min-width: 600px) and (max-width: 768px) {
    .firehydrant-card {
        width: 90%;
        padding: 15px;
    }
}

/* Large devices (laptops/desktops, 768px and up) */
@media only screen and (min-width: 768px) {
    .firehydrant-card {
        width: 80%;
        padding: 20px;
    }
}
</style>
